// @tennis-matches/services/settings/defaults
// Migrated from src/services/settings/defaults.js

/**
 * Default user settings
 */
export const DEFAULT_SETTINGS = {
  fontSize: "m",
  courtColor: "blue", // Default: indoor (blue)
  trainerstundenCalendarDayStart: "08:00",
  trainerstundenCalendarDayEnd: "20:00",
  /** Startzeit-Raster für Planung/Verschieben (Minuten): 5, 10, 15, 30 oder 60 */
  trainerstundenTimeSlotMinutes: 15,
  trainerstundenTrainingState: "",
  /** Schulferien im Kalender (via OpenHolidays, an Trainingsregion gekoppelt) */
  trainerstundenSchoolHolidaysEnabled: false,
  /** Rechnungs-E-Mails nur simulieren (kein Versand an Eltern) — Standard: an */
  trainerstundenBillingEmailSimulation: true,
  /** Trainings beim Anlegen optional im Belegungsplan hinterlegen */
  trainerstundenBelegungPlanningEnabled: false,
  /** Trainingsstunden: Anwesenheit nach Frist automatisch bestätigen */
  trainerstundenAttendanceAutoConfirmEnabled: false,
  /** Minuten nach Trainingsende bis zur Auto-Bestätigung (nur wenn aktiviert) */
  trainerstundenAttendanceAutoConfirmDelayMinutes: 0,
  /** Mobile: Formularmodus beim Anlegen von Trainings (standard|individual) */
  mobileTrainingCreateFormMode: "standard",
  /** Mobile: sichtbare Felder im individuellen Formularmodus */
  mobileTrainingCreateFormFieldVisibility: {
    location: true,
    courtFormat: true,
    assistant: true,
    notes: true,
  },
  preferredHomeApp: "hub",
  preferred_home_app: "hub",
  hubTourFavorites: { players: [], tournaments: [] },
};

/**
 * Determines default court color based on tournament start date month
 * Oct, Nov, Dec, Jan, Feb, Mar = Indoor (blue)
 * Rest = Outdoor (orange)
 * @param {string} startDate - ISO date string (YYYY-MM-DD) or empty
 * @returns {string} "blue" | "orange"
 */
export function getDefaultCourtColorByMonth(startDate) {
  if (!startDate || typeof startDate !== "string") return "blue"; // Default: indoor

  try {
    const date = new Date(startDate);
    if (Number.isNaN(date.getTime())) return "blue";
    const month = date.getMonth() + 1; // 1-12

    // Indoor months: Oct (10), Nov (11), Dec (12), Jan (1), Feb (2), Mar (3)
    if (month >= 10 || month <= 3) return "blue";
    // Outdoor months: Apr (4), May (5), Jun (6), Jul (7), Aug (8), Sep (9)
    return "orange";
  } catch (_) {
    return "blue"; // Default: indoor
  }
}
